// Counter animation for stats numbers
document.addEventListener('DOMContentLoaded', function() {
  var counters = document.querySelectorAll('.stats-card__number');

  if (counters.length === 0) return;

  function animateCounter(el) {
    var raw = el.getAttribute('data-target');
    var hasPlus = raw.indexOf('+') !== -1;
    var clean = raw.replace(/[^0-9]/g, '');
    var target = parseInt(clean, 10);

    if (isNaN(target)) return;

    var duration = 2000;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      el.textContent = current + (hasPlus ? '+' : '');

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target + (hasPlus ? '+' : '');
      }
    }

    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(function(counter) {
    observer.observe(counter);
  });
});
